import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.PopupTransferOrganisation', {
    title: 'Transfer Organisation',
    description: 'Organisation transfer request will be sent to Account owner for review.',
    descriptionCreateAccount:
        'If organisation transfer will be allowed, new account, subscription will be created in case non of the above already exists.',
    takeOverOrganisationTransferSuccess: 'Organisation transfer request sent for review',
    confirmCheckboxText:
        "I understand that this Organisation is connected to the selected Accounting Software account, this connection can't be updated or changed.",
    transferButton: 'Transfer organisation',
});
